import React from 'react';

export default function TitleH1({ title }) {
  return <h1>{title}</h1>;
}
